import { useEffect, useState } from "react";
import Button from "../../components/button";
import CardContainer from "../../components/card_container";
import Input from "../../components/input";
import InputImage from "../../components/input_image";
import InputSwitch from "../../components/input_switch";
import TextArea from "../../components/text_area";
import "./fabric.scss";
import UseFormFabric from "./hookForm";
import { useLocation } from "react-router-dom";
import useGet from "../../hooks/useGet";
import LoadingModal from "../../components/loading_modal";
import Select from "../../components/select";
import { axios } from "../../helpers";
import { useSelector } from "react-redux";
import { loginData } from "../../stores/auth";
const EditFabricsPage = () => {
  // const location = useLocation()
  // const [state, setState] = useState({})
  const dataLogin = useSelector(loginData);
  const {
    isLoadingPut,
    form,
    isOn,
    removePreview,
    handleSwitch,
    handleChange,
    handleImageChange,
    handleSubmit,
  } = UseFormFabric({
    type: "put",
  });

  let [product, setProduct] = useState([]);
  const getProduct = async () => {
    await axios
      .get("/v1/fabric/product", {
        headers: { Authorization: `Bearer ${dataLogin.data.token}` },
      })
      .then((res) => {
        let tmp = [];
        res.data.data.map((item) => {
          tmp.push({ value: item._id, label: item.name });
        });
        setProduct([{ value: "", label: "-- Select Product --" }, ...tmp]);
      });
  };
  useEffect(() => {
    getProduct();
  }, []);
  return (
    <>
      <CardContainer
        title={"Edit Data"}
        isBack={true}
        children={
          <form className="" onSubmit={(e) => handleSubmit(e)}>
            <div className="form-fabric">
              <div className="expanded-y">
                <Input
                  value={form.fabric_name}
                  style={{ width: "100%" }}
                  id="fabric_name"
                  onChange={handleChange}
                  label="Fabric Name"
                  placeholder="Input fabric name"
                  required={true}
                />
                <Input
                  value={form.brand}
                  style={{ width: "100%" }}
                  id="brand"
                  onChange={handleChange}
                  label="Brand"
                  placeholder="Input brand fabric"
                  required={true}
                />
                <Input
                  value={form.stock_code}
                  style={{ width: "100%" }}
                  id="stock_code"
                  onChange={handleChange}
                  label="Stock Code"
                  placeholder="Input stock code"
                  required={true}
                />
                <Input
                  value={form.pattern}
                  style={{ width: "100%" }}
                  id="pattern"
                  onChange={handleChange}
                  label="Pattern"
                  placeholder="Input pattern"
                  required={true}
                />
                <Input
                  value={form.color}
                  style={{ width: "100%" }}
                  id="color"
                  onChange={handleChange}
                  label="Color"
                  placeholder="Input color"
                  required={true}
                />
                <Input
                  value={form.material}
                  style={{ width: "100%" }}
                  id="material"
                  onChange={handleChange}
                  label="Material"
                  placeholder="Ex: cotton, silk, flanel, etc"
                  required={true}
                />
                <Select
                  label="Product"
                  id="product"
                  value={form.product}
                  onChange={handleChange}
                  required={true}
                  options={product}
                  style={{ width: "100%" }}
                />
                <Input
                  style={{ width: "100%" }}
                  id="price"
                  onChange={handleChange}
                  label="Price"
                  placeholder="Input Price"
                  type="number"
                  min={0}
                  value={form.price}
                  // required={true}
                />
                <TextArea
                  style={{ width: "100%" }}
                  id="description"
                  onChange={handleChange}
                  label="Description"
                  placeholder="Input Description"
                  value={form.description}
                  // required={true}
                />
                {/* <Input
                  value={form.type}
                  style={{ width: "100%" }}
                  id="type"
                  onChange={handleChange}
                  label="Type"
                  placeholder="Ex: shirt,batik,suit,vest"
                  required={true}
                /> */}
                <InputImage
                  value={form.image}
                  label={"Fabric Image"}
                  removePreview={() => removePreview()}
                  onChange={(e) => handleImageChange(e)}
                  required={true}
                />
                <InputSwitch
                  label={"Status"}
                  isOn={isOn}
                  onClick={() => handleSwitch("")}
                />
              </div>
              <hr style={{ width: "100%" }} />
              <div className="footer-form">
                <Button
                  type="button"
                  className="btn-outline-primary"
                  style={{ marginRight: "8px" }}
                  title="Cancel"
                  onClick={() => window.history.back()}
                />
                <Button type="submit" className="btn-primary" title="Save" />
              </div>
            </div>
          </form>
        }
      />
      <LoadingModal isLoading={isLoadingPut} />
    </>
  );
};
export default EditFabricsPage;
